import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaBed, FaBath, FaRulerCombined } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const ProjectCard = ({ project, animationDelay = 0 }) => {
  const { t } = useTranslation();

  return (
    <motion.div 
      key={project.id}
      className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col h-full min-h-[480px]"
      whileHover={{ y: -5 }}
    >
      {/* Image avec ratio fixe pour un meilleur rendu mobile */}
      <div className="relative w-full pb-[66%] overflow-hidden">
        <img 
          src={project.image} 
          alt={project.title}
          className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-bold">{project.title}</h3>
          <span className="bg-socabeg-blue/10 text-socabeg-blue text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ml-2">
            {project.type}
          </span>
        </div>
        
        <div className="grid grid-cols-2 gap-2 my-4 text-sm text-gray-600">
          {project.chambres > 0 && (
            <div className="flex items-center">
              <FaBed className="mr-2 text-socabeg-blue" />
              <span>{i18n.language === 'fr' ? `${project.chambres} Ch.` : `${project.chambres} Bed`}</span>
            </div>
          )}
          {project.sdb > 0 && (
            <div className="flex items-center">
              <FaBath className="mr-2 text-socabeg-blue" />
              <span>{i18n.language === 'fr' ? `${project.sdb} Sdb` : `${project.sdb} Bath`}</span>
            </div>
          )}
          <div className="flex items-center">
            <FaRulerCombined className="mr-2 text-socabeg-blue" />
            <span>{project.details?.superficie || project.area}</span>
          </div>
          <div className="flex items-center">
            <FaMapMarkerAlt className="mr-2 text-socabeg-blue" />
            <span className="truncate">
              {project.location.split(',')[0]}
            </span>
          </div>
        </div>

        <div className="mt-auto pt-4 border-t border-gray-100 flex-shrink-0">
          <div className="flex justify-between items-center mb-3">
            <span className="text-socabeg-blue font-bold text-sm">
              {(i18n.language === 'fr' ? 'Prix : ' : 'Price: ')}{project.price}
            </span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Link 
              to={`/promotion-immobiliere/projet/${project.id}`}
              className="bg-white border border-socabeg-blue text-socabeg-blue px-3 py-2 rounded-md hover:bg-socabeg-blue/5 transition-colors text-sm font-medium text-center"
            >
              {t('projects.viewDetails')}
            </Link>
            <Link 
              to="/contact"
              className="bg-socabeg-blue text-white px-3 py-2 rounded-md hover:bg-socabeg-blue-dark transition-colors text-sm font-medium text-center"
            >
              {t('projects.contactUs')}
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;
